import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BuiltBrandLockup } from './ui/BuiltBrandLockup';
import { CookiePreferencesModal } from './privacy/CookiePreferencesModal';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const [cookieOpen, setCookieOpen] = useState(false);

  return (
    <footer className="border-t border-white/[0.06] mt-auto" style={{ backgroundColor: '#0c0c0c' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-end justify-between gap-8">
          <div className="text-center lg:text-left">
            <Link to="/" className="inline-flex hover:opacity-90 transition-opacity">
              <BuiltBrandLockup heightClass="h-8" />
            </Link>
            <p className="font-display text-sm italic tracking-wide text-gray-500 mt-3">
              Every car has a story.
            </p>
            <p className="text-gray-600 text-xs mt-2">
              © {year} Tangents LLC. All rights reserved.
            </p>
          </div>

          <nav aria-label="Legal" className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm text-gray-400">
            <Link to="/support" className="hover:text-gray-200">Support and safety</Link>
            <Link to="/privacy" className="hover:text-gray-200">Privacy</Link>
            <Link to="/terms" className="hover:text-gray-200">Terms</Link>
            <Link to="/community-guidelines" className="hover:text-gray-200">Community</Link>
            <Link to="/cookies" className="hover:text-gray-200">Cookies</Link>
            <button
              type="button"
              className="hover:text-gray-200 min-h-[44px] sm:min-h-0"
              onClick={() => setCookieOpen(true)}
            >
              Cookie preferences
            </button>
            <Link to="/copyright" className="hover:text-gray-200">Copyright</Link>
            <Link to="/settings/privacy" className="hover:text-gray-200">Privacy center</Link>
          </nav>

          <a
            href="https://instagram.com/on.tangents"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-gray-400 hover:text-gray-300 transition-colors group"
            aria-label="Visit Tangents LLC on Instagram"
          >
            <img
              src="/tangents-logo.png"
              alt=""
              className="w-9 h-auto opacity-80 group-hover:opacity-100 transition-opacity"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <span className="text-sm">Designed & developed by Tangents</span>
          </a>
        </div>
      </div>
      <CookiePreferencesModal isOpen={cookieOpen} onClose={() => setCookieOpen(false)} />
    </footer>
  );
};

export default Footer;
